type ChipColor =
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "info"
  | "success"
  | "warning";

/**
 * Visual color per job title. Lookup by `Job.title`.
 *
 * Colors group by tier instead of being unique:
 *   Director médico / Gerenta médica            → error    (red — leadership)
 *   Veterinario titular / Veterinario general   → primary  (blue — vets)
 *   Auxiliar veterinario / Interno veterinario  → secondary (purple — support)
 *   Asesor                                       → success  (green)
 *   Encargado de dirección administrativa       → warning  (amber — admin)
 *
 * Unknown/legacy titles fall through to `default`.
 */
export const JOB_TITLE_CHIP_COLOR: Record<string, ChipColor> = {
  "Director médico": "error",
  "Gerenta médica": "error",
  "Veterinario titular": "primary",
  "Veterinario general": "primary",
  "Veterinario especialista": "primary",
  "Auxiliar veterinario": "secondary",
  "Interno veterinario": "secondary",
  "Practicante veterinario": "secondary",
  "Recepcionista": "info",
  "Asesor": "success",
  "Director administrativo": "warning",
  "Encargado de dirección administrativa": "warning",
  "Gerente": "warning",
};

export const getJobTitleChipColor = (title?: string): ChipColor =>
  (title && JOB_TITLE_CHIP_COLOR[title]) || "default";
